/**
* @file 运营中心-公司钱包
* */
<template>
  <div id="organizationFlowing">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" labelWidth="95"
                  has-organization="true"
                  @list="getFlowing"
                  organization-default="true"
                  >
      <template slot="customTable-top">
        <div class="flowing-top-bar">
          <el-radio-group v-model="customOptions.params.type" @change="statusChange">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="item.value" v-for="item in $const.FLOWINGTYPE" :key="item.value">{{item.label}}</el-radio-button>
          </el-radio-group>
          <div class="flowing-info" v-if="mixinUserInfo.organizationType === 1">
            <span class="flowing-label">机构余额</span>
            <span class="flowing-amount">￥{{flowing||0}}</span>
            <span class="flowing-tip">后台代下的订单，产生的退票或改签费用，会退回机构余额</span>
          </div>
        </div>
      </template>
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{row.created | filterTime}}</template>
        <template v-else-if="item.prop === 'type'">
          <span>{{row[item.prop] | filterConst('FLOWINGTYPE')}}</span>
        </template>
        <template v-else-if="item.prop === 'detail'">
          <span :class="row.type | filterConst('FLOWINGTYPE','class')">{{row.type|filterConst('FLOWINGTYPE','type')}}{{row.fee}}</span>
          <span
            v-if="row.type!==1">（订单号{{row.orderNo}}）</span>
        </template>
        <template v-else>{{row[item.prop] ? row[item.prop] : '-'}}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
  export default {
    name: "organizationFlowing",
    data () {
      return {
        // 配置项
        customOptions: {
          // 请求的列表url
          url: '/api/v1/manage/organization/flowing',
          // 请求的参数列表
          params: {
            type: '',
            page: 1, // 页数
            size: 20 // 每页条数
          },
          search: [
            {type: 'datetime', field: 'time', name: '发生时间', value: []}
          ]
        },
        // 表头
        columns: [
          {prop: 'type', label: '类型'},
          {prop: 'detail', label: '明细'},
          {prop: 'created', label: '发生时间'}
        ],
        flowing: ''
      }
    },
    methods: {
      async getFlowing () {
        if (this.mixinUserInfo.organizationType === 2) {
          return
        }
        let url = '/api/v1/manage/organization/flowing/' + this.customOptions.params.organizationId
        let data = await this.$axios.get(url)
        if (data && data.code === 1) {
          this.flowing = data.data
        }
      },
      /**
       * 状态改变
       */
      statusChange () {
        this.customOptions.params.page = 1
        this.$refs.customTable.listFn();
      }
    }
  }
</script>

<style lang="less" scoped>
#organizationFlowing {
  height: 100%;
  box-sizing: border-box;

  .flowing-top-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    padding-bottom: 16px;

    .el-radio-group {
      margin-bottom: 0;
    }

    .flowing-info {
      display: flex;
      align-items: center;
      gap: 8px;

      .flowing-label {
        font-size: 14px;
        color: #606266;
      }

      .flowing-amount {
        font-size: 18px;
        font-weight: 600;
        color: #ff9900;
      }

      .flowing-tip {
        font-size: 12px;
        color: #909399;
        padding-left: 8px;
        border-left: 1px solid #dcdfe6;
      }
    }
  }
}
</style>
